import React from 'react';
import Front from './front';
import close from './img/close-circle-line.png'

class FrontOverlay extends React.Component {
    
  constructor(props) {
      super(props);
      this.state = {
        devis:false
      }
  }

  componentDidMount() {
    this.props.api.registerFrontOverlay(this)
  }

  componentWillUnmount() {
    this.props.api.unregisterFrontOverlay(this)
  }

  open(devis) {
    this.setState({devis:devis})
  }

  render() {
    return this.state.devis 
      ? <><div className="front_overlay_back" onClick={this.open.bind(this,false)}>
        </div>
          <div className="front_overlay">
            <div className="front_overlay_header" onClick={this.open.bind(this,false)}>
              <img src={close}/>
              {this.state.devis.params.nom} {this.state.devis.params.prenom} 
              <span><a target="_blank" href={this.props.api.frontUrl(this.state.devis._id.$oid)}>Interface client ▸</a></span>
            </div>
            <div className="front_overlay_container">
              <Front api={this.props.api} id={this.state.devis._id.$oid} embeded={true}/>
            </div>
        </div>
        </>
    : ''
  }
}

export default FrontOverlay;
